var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('document-list',{attrs:{"config":_vm.config,"getConfigForExpandedItem":_vm.getConfigForExpandedItem,"disableSort":true,"isToolbarShown":false,"showExpand":true,"subVdtId":"_signatureDetails"}})
}
var staticRenderFns = []

export { render, staticRenderFns }